import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import BankAccountsInput from './BankAccountsInput';

const BankAccountsInputController = ({
  name = "bankaccounts",
  label = "Bank Account Details",
  helptext,
}) => {

  const { control, setValue, formState: { errors } } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => (
        <BankAccountsInput
          {...field}
          label={label}
          errors={errors}
          helptext={helptext}
          onChange={(accounts) => {
            setValue(field.name, accounts);
          }}
        />
      )}
    />
  );
};

export default BankAccountsInputController;
